import script from "./ShoppingCart.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoppingCart.vue?vue&type=script&setup=true&lang=js"

import "./ShoppingCart.vue?vue&type=style&index=0&id=9809047e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9809047e"]])

export default __exports__